import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const services = [
  {
    n: "01",
    title: "Creative Concept",
    desc: "Script to storyboard — big ideas shaped for the screen and tuned to your brand before a single frame is made.",
  },
  {
    n: "02",
    title: "AI Production",
    desc: "Full-scale commercial production powered by generative pipelines. Cinematic frames at a fraction of traditional timelines.",
  },
  {
    n: "03",
    title: "Digital Optimization",
    desc: "Every cut versioned, tested and refined for each platform — so the work performs as beautifully as it looks.",
  },
  {
    n: "04",
    title: "TV Broadcast Delivery",
    desc: "Broadcast-grade masters, cleared and delivered to spec for networks and stations worldwide.",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="px-6 py-28 md:px-10 md:py-40">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mb-16 flex flex-col gap-6 md:mb-20 md:flex-row md:items-end md:justify-between"
        >
          <div>
            <span className="font-mono text-[10px] tracking-[0.45em] text-zinc-500">SERVICES</span>
            <h2 className="mt-4 font-serif text-4xl tracking-tight sm:text-5xl lg:text-6xl">
              What we do, end to end.
            </h2>
          </div>
          <span className="font-mono text-[10px] tracking-[0.45em] text-zinc-600">
            04 CAPABILITIES
          </span>
        </motion.div>

        <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 md:grid-cols-2 lg:grid-cols-4">
          {services.map((service, i) => (
            <motion.div
              key={service.n}
              data-testid={`service-card-${service.n}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: EASE }}
              className="group flex min-h-[280px] flex-col justify-between bg-[#050505] p-10 transition-colors duration-500 hover:bg-[#0c0c0c] md:p-12"
            >
              <span className="font-mono text-xs tracking-[0.3em] text-zinc-600 transition-colors duration-500 group-hover:text-[#E1A730]">
                {service.n}
              </span>
              <div>
                <h3 className="font-serif text-2xl tracking-tight">{service.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-zinc-500">{service.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
